const contactsResources = {
  en: {
    translation: {
      'Contacts title': 'Contact us at:',
      'Contacts city': 'Almaty',
      'Contacts day-off': 'day off',
      'Contacts1 address': '187B N. Nazarbayev Avenue, Almaty',
      'Contacts1 schedule1': 'Mo-Fri',
      'Contacts1 schedule2': 'Sa-Su',
      'Contacts2 address': '189, Muratbayev Street (Branch), Almaty',
      'Contacts2 schedule1': 'Mo-Fri0',
      'Contacts2 schedule2': 'Sa',
      'Contacts2 schedule3': 'Su',
      'Contacts3 address': '18A Micro district Aksai 5 (Branch), Almaty',
      'Contacts3 schedule1': 'Mo-Fi',
      'Contacts3 schedule2': 'Sa',
      'Contacts3 schedule3': 'Su',
    },
  },
  kz: {
    translation: {
      'Contacts title': 'Біздің байланыстарымыз',
      'Contacts city': 'Алматы',
      'Contacts day-off': 'Демалыс',
      'Contacts1 address': 'Алматы қ., Н.Назарбаев даңғ. 187Б ',
      'Contacts1 schedule1': 'Дс- Жм',
      'Contacts1 schedule2': 'Сб. Жс',
      'Contacts1 day-off': 'Демалыс',
      'Contacts2 address': 'Алматы қ., Мұратбаев көш., 189 (филиал)',
      'Contacts2 schedule1': 'Дс- Жм',
      'Contacts2 schedule2': 'Сб',
      'Contacts2 schedule3': 'Жc',
      'Contacts3 address': 'Алматы қ., 5 Ақсай  ы/ауд., 18А (филиал)',
      'Contacts3 schedule1': 'Дсн- Жм',
      'Contacts3 schedule2': 'Сб',
      'Contacts3 schedule3': 'Жс',
    },
  },
  ru: {
    translation: {
      'Contacts title': 'Наши контакты',
      'Contacts city': 'Алматы',
      'Contacts day-off': 'Выходной',
      'Contacts1 address': 'г.Алматы, пр-т Н.Назарбаева 187Б, БЦ «STAR»',
      'Contacts1 schedule1': 'Пн- Пт',
      'Contacts1 schedule2': 'Сб. Вс',
      'Contacts2 address': 'г.Алматы, Муратбаева, 189 (филиал)',
      'Contacts2 schedule1': 'Пн- Пт',
      'Contacts2 schedule2': 'Сб',
      'Contacts2 schedule3': 'Вс',
      'Contacts3 address': 'г.Алматы, мкр. Аксай 5, 18А (филиал)',
      'Contacts3 schedule1': 'Пн- Пт',
      'Contacts3 schedule2': 'Сб',
      'Contacts3 schedule3': 'Вс',
    },
  },
};

export default contactsResources;
